// ==============================|| DEPOSIT ICON ||============================== //

const DepositIcon = ({ color = '#000', width = 24, className = '' }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill={color}
        d="M58.7,34.1H7.2c-1,0-1.8.8-1.8,1.8v27.4c0,1,.8,1.8,1.8,1.8h51.5c1,0,1.8-.8,1.8-1.8v-27.4c0-1-.8-1.8-1.8-1.8ZM13.3,59.4c0,.6-.4,1-1,1s-1-.4-1-1v-19.8c0-.6.4-1,1-1s1,.4,1,1v19.8ZM20.2,59.4c0,.6-.4,1-1,1s-1-.4-1-1v-19.8c0-.6.4-1,1-1s1,.4,1,1v19.8ZM27.1,59.4c0,.6-.4,1-1,1s-1-.4-1-1v-19.8c0-.6.4-1,1-1s1,.4,1,1v19.8ZM34,59.4c0,.6-.4,1-1,1s-1-.4-1-1v-19.8c0-.6.4-1,1-1s1,.4,1,1v19.8ZM40.9,59.4c0,.6-.4,1-1,1s-1-.4-1-1v-19.8c0-.6.4-1,1-1s1,.4,1,1v19.8ZM47.8,59.4c0,.6-.4,1-1,1s-1-.4-1-1v-19.8c0-.6.4-1,1-1s1,.4,1,1v19.8ZM54.7,59.4c0,.6-.4,1-1,1s-1-.4-1-1v-19.8c0-.6.4-1,1-1s1,.4,1,1v19.8ZM33,21.9c-1.8,0-2.7-.8-2.7-.8-.9-.8-1.5-1.9-1.5-3.1,0-2,1.4-3.6,3.2-4.1v-2.6h-2.9c-.9,0-1.7-.7-1.9-1.6l-1.1-6.3c-.1-.6,0-1.2.4-1.7.4-.4.9-.7,1.5-.7h10c.6,0,1.1.3,1.4.7.4.5.6,1.1.4,1.7l-1.1,6.3c-.2.9-1,1.6-1.9,1.6h-2.8v3.5c0,.5-.4,1-1,1-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2,2.2-1,2.2-2.2.5-1,1-1,1,.5,1,1c0,1.3-.6,2.4-1.4,3.1,0,0-1.3.8-2.8.8Z"
      />
    </svg>
  );
};

export default DepositIcon;
